<script setup lang="ts">
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import { useData } from '../../_composables/useData';
import { type BreadcrumbItem } from '#imports';

const { hotelPackage, loadingClass, title } = useData();
const router = useRouter();

const h1Title = computed(
    () =>
        `رزرو ${hotelPackage.value.title || ''} ${hotelPackage.value?.cityTitle ? hotelPackage.value?.cityTitle : ''}`
);

const route = useRoute();

const breadcrumbItems = computed<BreadcrumbItem[]>(() => [
    {
        link: '/',
        title: 'مِستربلیط',
    },
    {
        link: '/hotel',
        title: 'رزرو هتل',
    },
    {
        link: `/hotel/${hotelPackage.value.cityName}`,
        title: `رزرو هتل ${hotelPackage.value.cityTitle}`,
    },
    {
        link: route.path,
        title: `رزرو ${title.value} ${hotelPackage.value.cityTitle}`,
    },
]);
const searchAgain = () => router.push('/hotel');
</script>
<template>
    <div class="hotel-page-header-wrapper">
        <header class="hotel-page-header">
            <div class="header-breadcrumb-wrapper">
                <mr-typography
                    type="h1"
                    :size="{
                        desktop: 'display3',
                        mobile: 'medium',
                    }"
                    weight="700"
                    color="white"
                    :class="loadingClass"
                >
                    {{ h1Title }}
                </mr-typography>
                <mr-breadcrumb
                    class="breadcrumb"
                    theme="light"
                    :items="breadcrumbItems"
                />
            </div>
            <mr-button
                class="desktop"
                :right-icon="faSearch"
                @click="searchAgain"
            >
                جستجوی مجدد
            </mr-button>
            <mr-button
                class="mobile"
                :icon-button="faSearch"
                @click="searchAgain"
            />
        </header>
        <img
            class="image-background"
            alt="هتل مِستربلیط"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAwAAAADICAYAAABf0obKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQESURBVHgB7ddBAQAQAAAxFFBaah+C3NZic5/7BgAAkLAGAACQIQAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQIgAAABAiAAAAECIAAAAQ8gFHNgQcV0aoRAAAAABJRU5ErkJggg=="
        />
    </div>
</template>
<style scoped lang="scss">
.hotel-page-header-wrapper {
    position: relative;
    height: 110px;
    width: 100%;
    background: usePalette();
    overflow: hidden;
    margin-bottom: -26px;
    @include mobile-only {
        margin: 0;
    }
    .hotel-page-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: $app-container-max-width;
        margin: auto;
        padding: 0 25px 0 16px;
        @include mobile-only {
            justify-content: flex-start;
            padding: 0 16px 16px 0;
            margin: 0;
            height: 100%;
        }
        .header-breadcrumb-wrapper {
            @include mobile-only {
                margin-left: auto;
            }
            .breadcrumb {
                @include mobile-only {
                    position: absolute;
                }
            }
        }
        .mobile {
            @include desktop-only {
                display: none;
            }
        }
        .desktop {
            @include mobile-only {
                display: none;
            }
        }
    }
    .image-background {
        position: absolute;
        inset: 0 0 0 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }
}
</style>
